import localStorage from '../../storage/localStorage';

export default localStorage(
  `/porsche/cops/auth/access/token/${process.env.REACT_APP_ENV || 'random'}`
);
